import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import MessageModel, { FunctionType } from "@/commons/models/Message";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * メッセージ API 操作クラス
 */
export default class Messages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET Messages
   */
  public async gets(
    userStore: LoginUser,
    queryParams: {
      functionType: FunctionType;
      startIndex: number;
      endIndex: number;
      order: string;
      onlyReplyUnreaded: "true";
      start: string;
      end: string;
    }
  ): Promise<Array<MessageModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl = UrlFormatter.format(RestUrl.MessagesInFacility, formatParams);
    const response = await this.commonService.executeGet<Array<MessageModel>>(userStore, requestUrl, this.constructor.name, queryParams, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * GET MessagesCount
   */
  public async getCount(userStore: LoginUser, queryParams: { functionType: FunctionType }): Promise<number> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl = UrlFormatter.format(RestUrl.MessagesInFacility, formatParams);
    // countの場合は末尾に「count」をつける
    const response = await this.commonService.executeGet<{ count: number }>(
      userStore,
      `${requestUrl}/count`,
      this.constructor.name,
      queryParams,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data.count;
  }

  /**
   * DELETE Messages
   */
  public async delete(userStore: LoginUser, datetime: number | string): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MessageByDatetime, formatParams);
    const response = await this.commonService.executeDelete<any>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
